module.exports = __webpack_public_path__ + "img/v-1.a27dd5b4.png";